const HEIGHT = '--app-height';
const TOP = '--app-top';

function isStandalone(): boolean {
  const mq = window.matchMedia?.('(display-mode: standalone)').matches;
  const ios = Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
  return Boolean(mq || ios);
}

function apply(): void {
  const vv = window.visualViewport;
  const inner = Math.round(window.innerHeight || document.documentElement.clientHeight || 0);
  let top = 0;
  let h = inner;

  if (isStandalone() && vv && vv.height > 0) {
    // A2HS / installed PWA: visualViewport tracks the usable screen.
    top = Math.round(vv.offsetTop || 0);
    h = Math.round(vv.height);
  } else {
    // Chrome (and other) mobile webpage: VV height often undershoots and leaves a
    // cream gap above the browser toolbar. Fill the layout viewport instead.
    top = 0;
    // Prefer the larger of innerHeight and VV so we never leave a gap under the tabs.
    const vvH = vv && vv.height > 0 ? Math.round(vv.height + (vv.offsetTop || 0)) : 0;
    h = Math.max(inner, vvH);
  }

  if (h > 0) {
    const px = `${h}px`;
    document.documentElement.style.setProperty(HEIGHT, px);
    document.body?.style.setProperty(HEIGHT, px);
  }
  document.documentElement.style.setProperty(TOP, `${top}px`);
}

export function initAppHeight(): () => void {
  apply();
  const onResize = () => apply();
  const onOrientation = () => {
    apply();
    window.setTimeout(apply, 250);
    window.setTimeout(apply, 600);
  };
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onOrientation);
  window.visualViewport?.addEventListener('resize', onResize);
  window.visualViewport?.addEventListener('scroll', onResize);
  document.addEventListener('visibilitychange', onResize);
  return () => {
    window.removeEventListener('resize', onResize);
    window.removeEventListener('orientationchange', onOrientation);
    window.visualViewport?.removeEventListener('resize', onResize);
    window.visualViewport?.removeEventListener('scroll', onResize);
    document.removeEventListener('visibilitychange', onResize);
  };
}
